import Header from "./Component/header";
import { Outlet } from "react-router-dom";
import { Footer } from "./Component/footer";

export const Layout = ({ cartCount }) => {
  return (
    <>
      <Header cartCount={cartCount} />
      <Outlet />
      <Footer />
    </>
  );
};
